import React from 'react';

import TaskListSetup from './tasks/TaskListSetup';

export default () => 
	{
		return (
			<TaskListSetup />
		);
	};

